import { gql } from "@apollo/client";

export const MUTATE_PROFILE = gql`
  mutation EditProfile(
    $socials: SocialsTypeInput
    $email: String
    $countryCode: String
    $username: String
  ) {
    editProfile(
      socials: $socials
      email: $email
      countryCode: $countryCode
      username: $username
    )
  }
`;

export const MUTATE_AVATAR = gql`
  mutation Mutation($key: String) {
    avatar(key: $key)
  }
`;

export const USER_DELETE = gql`
  mutation UserDelete {
    userDelete {
      success
    }
  }
`;

export const USER_ACTIVATE = gql`
  mutation UserActivate($input: UserActivateInput!) {
    userActivate(input: $input) {
      success
      errors {
        field
        code
      }
    }
  }
`;
